import { resolveIcon } from '../../styles/icons'
import { Link } from 'react-router-dom'
import { evaluateCondition } from '../../../../common/model/condition/evaluate.js'
import { AppIconColor } from '../../styles/IconStyle'
import usePath from '../../hooks/usePath'
import DisplayElement from '../display/DisplayElement'
import { TableDecorator } from './Table'
import {
    TableListMobile as TableList,
    TableListItemMobile as TableListItem,
    CardWrapper,
    Tags,
    Flex,
    LeftTag,
    LeftSubTag,
    RightTag,
    RightSubTag,
    IconWrapper,
    NoDataMobile as NoData,
    createSlugPath,
    hasValidData
} from './Common'

import styled from 'styled-components'

const TableLink = styled(Link)`
    text-decoration: none;
`

const StatusDot = styled.div`
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background-color: ${({ $status, theme }) => (theme.emotive[$status] || theme.emotive.disabled).color};
    flex-shrink: 0;
    align-self: center;
    margin-left: 0.5rem;
`

/**
 * Evaluates the status of an item based on the rightStatus configuration.
 * Each status key maps to an array of conditions that must ALL match (AND logic).
 * Statuses are evaluated in priority order: success, warning, error.
 * @param {object} item - The data item to evaluate
 * @param {object} rightStatus - The status configuration object
 * @returns {string|null} - The matched status key or null if none match
 */
const evaluateStatus = (item, rightStatus) => {
    const statusOrder = ['success', 'warning', 'error']
    for (const status of statusOrder) {
        const conditions = rightStatus[status]
        if (!conditions) continue
        const allMatch = conditions.every(({ field, value }) => item[field] === value)
        if (allMatch) return status
    }
    return 'disabled'
}


const TableRows_m = ({ endpoint, result, mobile, slug, tableKey = 'id', path = '', pathTemplate, emphasizeLine }) => {

    // format the path by merging the endpoint to the current url
    const { url } = usePath(path)

    const slugPath = createSlugPath(slug)

    const isEmphasized = (item) =>
        emphasizeLine ? evaluateCondition(emphasizeLine.condition, { values: item }) : false

    const resolveTemplate = (template, item) =>
        template.replace(/\{(\w+)\}/g, (_, key) => item[key] ?? '')

    const getItemUrl = (item) => {
        if (Array.isArray(pathTemplate)) {
            for (const pt of pathTemplate) {
                if (!pt.condition) return resolveTemplate(pt.template, item)
                if (item[pt.condition.field] === pt.condition.value) return resolveTemplate(pt.template, item)
            }
        }
        if (pathTemplate) return resolveTemplate(pathTemplate, item)
        return `${url}${item[tableKey]}${slugPath}`
    }

    if (!mobile) return null

    if (!hasValidData(result)) {
        // Handle the case when result data is empty
        return NoData
    }

    return (
        <TableList>
            <AppIconColor>
                {result.data.pages.map((page, pageIndex) => (
                    <div key={pageIndex}>
                        {
                            Array.isArray(page.data) && page.data.map(
                                (item, i) => {
                                    return (
                                        <TableListItem key={i} data-testid={`${endpoint}.list.${i+1}.m`} $emphasis={isEmphasized(item)}>
                                            <TableLink to={getItemUrl(item)}>
                                                <CardWrapper>
                                                    <div>
                                                        <Flex>
                                                            <IconWrapper $padding={mobile?.left?.iconPadding || '0'}>
                                                                {mobile?.left?.icon ? resolveIcon(mobile?.left?.icon) : <></>}
                                                            </IconWrapper>
                                                            <Tags>
                                                                <LeftTag><DisplayElement
                                                                    string={item[mobile?.left?.tag?.field]}
                                                                    type={mobile?.left?.tag?.type}
                                                                    prefix={mobile?.left?.tag?.prefix}
                                                                />
                                                                    {mobile?.left?.tag?.decorator ? <TableDecorator>{item[mobile?.left?.tag.decorator]}</TableDecorator> : <></>}
                                                                </LeftTag>
                                                                <LeftSubTag><DisplayElement
                                                                    string={item[mobile?.left?.subTag?.field]}
                                                                    type={mobile?.left?.subTag?.type}
                                                                    prefix={mobile?.left?.subTag?.prefix}
                                                                />
                                                                    {mobile?.left?.subTag?.decorator ? <TableDecorator>{item[mobile?.left?.subTag.decorator]}</TableDecorator> : <></>}
                                                                </LeftSubTag>
                                                            </Tags>
                                                        </Flex>
                                                    </div>
                                                    <Flex>
                                                        <Flex>
                                                            <div>
                                                                {mobile?.right?.tag ? (
                                                                    <RightTag><DisplayElement
                                                                        string={item[mobile?.right?.tag.field]}
                                                                        type={mobile?.right?.tag.type}
                                                                        prefix={mobile?.right?.tag.prefix}
                                                                        />
                                                                        {mobile?.right?.tag.decorator ? <TableDecorator>{item[mobile?.right?.tag.decorator]}</TableDecorator> : <></>}
                                                                    </RightTag>) : <></>}
                                                                {mobile?.right?.subTag ? (
                                                                    <RightSubTag><DisplayElement
                                                                        string={item[mobile?.right?.subTag.field]}
                                                                        type={mobile?.right?.subTag.type}
                                                                        prefix={mobile?.right?.subTag.prefix}
                                                                    />
                                                                        {mobile?.right?.subTag.decorator ? <TableDecorator>{item[mobile?.right?.subTag.decorator]}</TableDecorator> : <></>}
                                                                    </RightSubTag>) : <></>}
                                                            </div>
                                                            {mobile?.right?.status ? (() => {
                                                                const status = evaluateStatus(item, mobile?.right?.status)
                                                                return status ? <StatusDot $status={status} /> : <></>
                                                            })() : <></>}
                                                            {mobile?.right?.icon ? resolveIcon(mobile?.right?.icon) : <></>}
                                                        </Flex>
                                                    </Flex>
                                                </CardWrapper>
                                            </TableLink>
                                        </TableListItem>
                                    )
                                }
                            )
                        }
                    </div>)
                )}
            </AppIconColor>
        </TableList>
    )
}

export default TableRows_m
